import { useMutation } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { useIntl } from 'react-intl';

// common
import useService from 'common/hook/useService';

// screen
import { handleException } from 'modules/account/detail/helpers/utils';

export interface Password {
  password: string;
  passwordRetype: string;
}

export const defaultPassword: Password = {
  password: '',
  passwordRetype: '',
};

interface MutatingProps {
  userId: string;
  newPassword: string;
}

const useUpdatePassword = () => {
  const { formatMessage } = useIntl();
  const service = useService();

  return useMutation({
    mutationFn: async (props: MutatingProps) => {
      try {
        const { userId, newPassword } = props;
        if (!service || !props.newPassword) return null;

        const res = await service.UserManagementController_changePassword({
          params: { userId },
          body: { newPassword },
        });

        if (!res) return null;
        return { message: 'successful' };
      } catch (error) {
        const status = handleException(error, { notifyUser: false });
        if (status) {
          enqueueSnackbar({
            message: formatMessage({
              id: 'account.error.failToUpdatePassword',
            }),
            variant: 'error',
          });
        }
        throw error;
      }
    },
  }).mutateAsync;
};

export default useUpdatePassword;
